<template>
  <div class="uk-container test-results">
    <UserHeader />
    <h2>Billing</h2>

    <p class="uk-text-meta">
    Phase 1 demo: hosted Stripe Checkout for purchases &amp; subscriptions,
    and the Stripe Customer Portal for cards, invoices, and cancellations.
    </p>

    <hr />

    <h3>Make a purchase</h3>
    <div class="uk-margin">
    <label class="uk-form-label">Stripe Price ID</label>
    <input
        v-model="priceId"
        class="uk-input"
        placeholder="price_..."
    />
    </div>

    <div class="uk-margin">
    <label>
        <input class="uk-radio" type="radio" value="payment" v-model="mode" />
        One-time payment
    </label>
    &nbsp;&nbsp;
    <label>
        <input class="uk-radio" type="radio" value="subscription" v-model="mode" />
        Subscription
    </label>
    </div>

    <button
    class="uk-button uk-button-primary"
    :disabled="loading || !priceId"
    @click="checkout"
    >
    {{ loading ? 'Redirecting...' : 'Continue to Stripe Checkout' }}
    </button>

    <hr />

    <h3>Manage existing billing</h3>
    <p class="uk-text-meta">
    Update card on file, view payment history, download invoices, or cancel
    a subscription.
    </p>
    <button
    class="uk-button uk-button-default"
    :disabled="portalLoading"
    @click="openPortal"
    >
    {{ portalLoading ? 'Opening...' : 'Manage Billing' }}
    </button>

    <p v-if="error" class="uk-text-danger uk-margin">{{ error }}</p>
  </div>
</template>

<script>
import axios from 'axios';
import UserHeader from "./UserHeader.vue";

export default {
  name: 'BillingPage',
  created() {
    document.title = 'Billing | UCARI';
  },
  data() {
    return {
      priceId: '',
      mode: 'payment',
      loading: false,
      portalLoading: false,
      error: '',
    };
  },
  components: { UserHeader },
  methods: {
    async checkout() {
      this.error = '';
      this.loading = true;
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/stripe/checkout`,
          { priceId: this.priceId, mode: this.mode },
          { withCredentials: true }
        );
        if (data && data.url) {
          window.location = data.url;
        } else {
          this.error = 'No checkout URL returned.';
        }
      } catch (e) {
        this.error = e.response?.data?.error || e.message;
      } finally {
        this.loading = false;
      }
    },
    async openPortal() {
      this.error = '';
      this.portalLoading = true;
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/stripe/portal`,
          {},
          { withCredentials: true }
        );
        if (data && data.url) {
          window.location = data.url;
        } else {
          this.error = 'No portal URL returned.';
        }
      } catch (e) {
        this.error = e.response?.data?.error || e.message;
      } finally {
        this.portalLoading = false;
      }
    },
  },
};
</script>
